import React from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { HiMenuAlt4 } from "react-icons/hi";
import { AiOutlineClose } from "react-icons/ai";
import "./Navbar.css";
import { getUserData, logOut } from "../../services/authSlice";
import logo from "../../assets/logo.png";

// const NavBarItem = ({ title, classprops, hrefTo }) => (
//   <Link className={`mx-4 cursor-pointer ${classprops}`} to={hrefTo}>{title}</Link>
// );

const Navbar = ({ onBtnClicked }) => {
  const { uid } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const handleLogOut = () => {
    dispatch(logOut({}));
  };
  React.useEffect(() => {
    if (uid !== undefined) {
      dispatch(getUserData("user"));
    }
  }, [0]);
  const [toggleMenu, setToggleMenu] = React.useState(false);
  return (
    <nav className="w-full flex md:justify-center justify-between items-center pt-4 pb-5 notched">
      <div className="md:flex-[0.5] flex-initial justify-center items-center">
        <img src={logo} alt="logo" className="w-32 cursor-pointer" />
      </div>
      <ul className="text-white md:flex hidden list-none flex-row justify-between items-center flex-initial">
        {/* {["Home", "What is PortfolioX", "Projects", "Users"].map((item, index) => (
          <NavBarItem key={item + index} title={item} />
        ))} */}
        <Link className="mx-4 cursor-pointer my-2 text-lg" to="/">Videos</Link>
        <Link className="mx-4 cursor-pointer my-2 text-lg" to="/portfoliax">What is PortfolioX</Link>
        <Link className="mx-4 cursor-pointer my-2 text-lg" to="/portfoliax/users">Users</Link>
        {uid !== undefined ? (
          <>
            <Link to="/portfoliax/profile">My Profile</Link>
            <div className="bg-[#2952e3] py-2 px-7 mx-4 rounded-full cursor-pointer hover:bg-[#DC143C]" onClick={handleLogOut}>
              Logout
            </div>
          </>
        ) :
          (
            <div className="bg-[#2952e3] py-2 px-7 mx-4 rounded-full cursor-pointer hover:bg-[#2546bd]" onClick={onBtnClicked}>
              Login
            </div>
          )}
      </ul>
      <div className="flex relative">
        {!toggleMenu && (
          <HiMenuAlt4 fontSize={28} className="text-white md:hidden cursor-pointer" onClick={() => setToggleMenu(true)} />
        )}
        {toggleMenu && (
          <AiOutlineClose fontSize={28} className="text-white md:hidden cursor-pointer" onClick={() => setToggleMenu(false)} />
        )}
        {toggleMenu && (
          <ul
            className="z-10 fixed -top-0 -right-2 p-3 w-[70vw] h-screen shadow-2xl md:hidden list-none
            flex flex-col justify-start items-end rounded-md blue-glassmorphism text-white animate-slide-in"
          >
            <li className="text-xl w-full my-2"><AiOutlineClose onClick={() => setToggleMenu(false)} /></li>
            <Link className="mx-4 cursor-pointer my-2 text-lg" to="/">Videos</Link>
            <Link className="mx-4 cursor-pointer my-2 text-lg" to="/portfoliax/portfoliax">What is PortfolioX</Link>
            <Link className="mx-4 cursor-pointer my-2 text-lg" to="/portfoliax/users">Users</Link>
            {uid !== "" ? (
              <>
                <Link className="my-2 text-lg mx-4 cursor-pointer" to="/portfoliax/profile">My Profile</Link>
                <div className="bg-[#2952e3] py-2 px-7 mx-4 rounded-full cursor-pointer hover:bg-[#DC143C]" onClick={handleLogOut}>
                  Logout
                </div>
              </>
            ) :
              (
                <div className="bg-[#2952e3] py-2 px-7 mx-4 rounded-full cursor-pointer hover:bg-[#2546bd]" onClick={onBtnClicked}>
                  Login
                </div>
              )}
          </ul>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
